module.exports = __webpack_public_path__ + "img/70.cff1446c.jpg";